/**
 * A QUIEN SE LE HABLA.
 *
 * Es una distincion del proyecto, no un detalle del sitio: casi todas las
 * canalizaciones le hablan al HUMANO UNIVERSAL y NO nombran «trabajador de la
 * luz». Solo el bloque de Trabajadores de la Luz lo hace, y lo hace de frente
 * (Def 52).
 *
 * 🔴 POR ESO TRABAJADORES DE LA LUZ NO ES UNA VOZ, Y NO VA CON LAS TRECE.
 * Nadie firma como «Trabajadores de la Luz»: son a QUIENES Jeshua les habla.
 * Ponerlos entre las voces seria confundir quien habla con quien escucha.
 *
 * COMO SE RECONOCE UNA: por la sigla del ID. La sigla son las dos letras que
 * van tras los cuatro digitos y corresponden a la CARPETA DESTINO, no a la voz
 * — y las de Trabajadores de la Luz llevan siempre LW. Se deduce del ID en vez
 * de anotarse aparte porque el ID es la fuente de verdad del ruteo: si una
 * pieza se rutea a esa carpeta, su ID ya lo dice.
 *
 * 🔴 CUANTAS HAY NO SE ESCRIBE AQUI (30-ago). Este comentario decia «3
 * publicadas de 19» y en disco habia OCHO: el JSON del sitio llevaba cinco dias
 * sin regenerarse y nadie lo vio hasta que Faina echo en falta sus piezas. El
 * numero sale de `PIEZAS_TDL.length`, que cuenta; el JSON se regenera con
 * `herramientas/canalizaciones.py` y una prueba vigila que no vuelva a
 * separarse del disco.
 */

export const TDL = 'Trabajadores de la Luz';

/** ¿Esta pieza le habla a un trabajador de la luz? Lo dice su sigla. */
export const esTdL = (pieza) => /^\d{4}LW/.test(String(pieza && pieza.id));

/** Cuantas hay en el universo, para poder decir «N de 19» sin mentir. */
export const TDL_EN_EL_UNIVERSO = 19;

/**
 * Lo que el BUSCADOR tiene que saber de cada pieza sobre su destinatario.
 *
 * Faina, 26-ago: «en biblioteca, cuando meta al buscador la palabra
 * trabajadores de la luz, le desplegara todas las canalizaciones de ellos».
 *
 * 🔴 Y NO PODIA DEPENDER DE LAS PALABRAS DEL TEXTO: buscar «trabajadores de la
 * luz» en plural devolvia 2 de 3, porque «La soledad del pionero» solo dice
 * «trabajador» en singular. El buscador tiene que saber a quien va dirigida
 * cada pieza — eso lo dice su ID, no su redaccion.
 *
 * Se anaden las dos formas para que funcione se escriba como se escriba.
 */
export const destinatarioBuscable = (pieza) =>
  (esTdL(pieza) ? 'trabajadores de la luz trabajador de la luz lightworker' : '');
